import { HelpOutline } from '@mui/icons-material'
import { Badge, Stack, Tooltip } from '@mui/material'

/**
 * Generates a label for a filter accordion, optionally displaying a pip to
 * indicate that the filter is currently applied.
 */
export function FilterAccordionLabel({
    filterName,
    helperText,
    showDirtyDot = false,
}: {
    /** The name of the filter to apply to this accordion label. */
    filterName: string
    /** Some descriptive text to clarify the purpose of usage of this filter. */
    helperText?: string
    /** Whether to display a pip indicating that the related filter is active. */
    showDirtyDot?: boolean
}) {
    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
        >
            <Badge
                invisible={!showDirtyDot}
                color="info"
                variant="dot"
                slotProps={{ badge: { style: { top: '6px', right: '-6px' } } }}
            >
                {filterName}
            </Badge>

            {helperText && (
                <Tooltip title={helperText}>
                    <HelpOutline
                        fontSize="small"
                        sx={{ color: 'greyscale.grey_600' }}
                    />
                </Tooltip>
            )}
        </Stack>
    )
}
